import type { Impact, Lang } from "@/types";

export function fmtNum(n: number, digits = 2): string {
  return n.toLocaleString("zh-CN", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
}

export function fmtVolume(v: number): string {
  if (v >= 100000) return (v / 10000).toFixed(2) + "万手";
  return v.toLocaleString("zh-CN") + "手";
}

export function fmtFlow(v: number): string {
  const sign = v >= 0 ? "+" : "-";
  const abs = Math.abs(v);
  if (abs >= 10000) return `${sign}${(abs / 10000).toFixed(2)}亿`;
  return `${sign}${abs.toFixed(0)}万`;
}

export function fmtTime(iso: string): string {
  const d = new Date(iso);
  return d.toLocaleTimeString("zh-CN", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function fmtDate(iso: string): string {
  const d = new Date(iso);
  const now = new Date();
  const sameDay = d.toDateString() === now.toDateString();
  if (sameDay) return fmtTime(iso);
  return `${d.getMonth() + 1}/${d.getDate()} ${fmtTime(iso)}`;
}

export function relTime(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return "刚刚";
  if (min < 60) return `${min}分钟前`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}小时前`;
  return `${Math.floor(hr / 24)}天前`;
}

export function changeColor(pct: number): string {
  if (pct > 0) return "text-bull";
  if (pct < 0) return "text-bear";
  return "text-ink-300";
}

export function changeSign(pct: number): string {
  if (pct > 0) return "+";
  return "";
}

export const impactStyle: Record<Impact, { text: string; border: string; bg: string; label: string }> = {
  high: { text: "text-bull", border: "border-bull/60", bg: "bg-bull/10", label: "高影响" },
  medium: { text: "text-gold", border: "border-gold/60", bg: "bg-gold/10", label: "中影响" },
  low: { text: "text-ink-300", border: "border-ink-600", bg: "bg-ink-800", label: "低影响" },
};

export const langLabel: Record<Lang, string> = {
  zh: "中文",
  en: "英文",
  ja: "日文",
  other: "其他",
};
